const _wishlistCache = {
  loaded: false,
  items: [],
  metafieldId: null
};
const WISHLIST_COUNT_STORAGE_KEY = 'ax_wishlist_items_count';
const WISHLIST_HEADER_BADGE_ID = 'AX-wishlist-header-badge';

function updateWishlistHeaderBadge(count) {
  const safeCount = Math.max(0, Number(count) || 0);

  try {
    localStorage.setItem(WISHLIST_COUNT_STORAGE_KEY, String(safeCount));
  } catch (e) {
    console.warn('Wishlist OMC: Could not persist wishlist count.', e);
  }

  const badge = document.getElementById(WISHLIST_HEADER_BADGE_ID);
  if (!badge) return;

  if (safeCount > 0) {
    badge.textContent = String(safeCount);
    badge.removeAttribute('hidden');
    badge.setAttribute(
      'aria-label',
      `${safeCount} wishlist item${safeCount === 1 ? '' : 's'}`
    );
  } else {
    badge.textContent = '';
    badge.setAttribute('hidden', '');
    badge.setAttribute('aria-label', 'AX-wishlist items count');
  }
}

function applyWishlistCountFromStorage() {
  try {
    const stored = localStorage.getItem(WISHLIST_COUNT_STORAGE_KEY);
    if (stored != null) {
      updateWishlistHeaderBadge(parseInt(stored, 10));
    }
  } catch (e) {
    console.warn('Wishlist OMC: Could not read wishlist count from storage.', e);
  }
}

function syncWishlistCountFromItems(items) {
  const list = Array.isArray(items) ? items : [];
  updateWishlistHeaderBadge(list.length);
  return list;
}

function applyWishlistFromMetafieldResponse(metafield) {
  const rawItems = metafield ? JSON.parse(metafield.value) : [];
  const items = normalizeWishlistItems(rawItems);
  _wishlistCache.items = items;
  _wishlistCache.metafieldId = metafield ? metafield.id : null;
  syncWishlistCountFromItems(items);
  return items;
}

function normalizeWishlistItems(items) {
  if (!Array.isArray(items)) return [];

  return items.map((item) => {
    const productId = normalizeProductId(item?.id ?? item?.product_id);
    if (!productId) return null;

    const selectedVariants = Array.isArray(item?.selectedVariants) ? item.selectedVariants : [];
    const key = item?.key ? String(item.key) : buildWishlistKey(productId, selectedVariants);

    return {
      ...item,
      id: productId,
      key,
      selectedVariants
    };
  }).filter(Boolean);
}
let rawMainProductData = null;
let isReminderEnabled = false; // Global flag for the reminder feature
let comboProductsData = {};

function waitForElement(selector) {
  return new Promise(resolve => {
    const element = document.querySelector(selector);
    if (element) return resolve(element);
    const observer = new MutationObserver(() => {
      const element = document.querySelector(selector);
      if (element) {
        resolve(element);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
}

function getSelectedVariants() {
  const selected = [];

  document.querySelectorAll('.combo-row').forEach(row => {
    const sizeSelect = row.querySelector('.size-select');
    const colorSelect = row.querySelector('.color-select');

    if (!sizeSelect || !sizeSelect.value) return;

    const variantId = String(sizeSelect.value);
    const productId = String(colorSelect?.value || "");

    const productData = comboProductsData[productId];
    const variantData = productData?.variants?.[variantId];

    const color = productData?.colorname || "";
    const size = variantData?.var_title || "";

    selected.push({
      id: variantId,
      productId: productId,
      title: `${color}${size ? " / " + size : ""}`,
      quantity: 1,
      color,
      size
    });
  });

  selected.sort((a, b) => a.id.localeCompare(b.id));

  console.log("🔥 Selected variants:", selected);

  return selected;
}
function normalizeProductId(productId) {
  if (productId == null || productId === '') return '';
  const str = String(productId).trim();
  const gidMatch = str.match(/\/Product\/(\d+)$/i);
  return gidMatch ? gidMatch[1] : str;
}

function createCleanProductObject(fullProduct, selectedVariants = []) {
  const productId = normalizeProductId(fullProduct?.id ?? fullProduct?.product_id);
  if (!fullProduct || !productId) return null;

  const formatPrice = (priceInCents) => {
    if (!priceInCents) return "";
    const locale = Shopify?.locale || 'en-US';
    const currency = Shopify?.currency?.active || 'USD';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency
      }).format(priceInCents / 100);
    } catch {
      return `$${(priceInCents / 100).toFixed(2)}`;
    }
  };

  const firstVariant = fullProduct.variants?.[0] || {};
  const key = buildWishlistKey(productId, selectedVariants);

  return {
    id: productId,
    key,

    name: fullProduct.title,
    price: formatPrice(fullProduct.price),
    image: fullProduct.featured_image,
    description: fullProduct.body_html
      ? fullProduct.body_html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim().substring(0, 250) + '...'
      : '',
    url: `/products/${fullProduct.handle}`,
    vendor: fullProduct.vendor,
    type: fullProduct.type,
    tags: fullProduct.tags,

  
    selectedVariants: selectedVariants,

    variants: fullProduct.variants,
    available: fullProduct.available,
    compareAtPrice: formatPrice(fullProduct.compare_at_price),
    weight: firstVariant.weight,
    sku: firstVariant.sku
  };
}
function loadComboProductsData() {
  const script = document.querySelector('script[id^="ProductMetafieldsJSON-"]');
  if (!script) return;

  try {
    const data = JSON.parse(script.textContent);
    comboProductsData = data?.comboproducts || {};
    console.log("🔥 Combo products loaded:", comboProductsData);
  } catch (e) {
    console.error("Failed to parse combo products JSON", e);
  }
}
function storeRecentlyViewedProduct(product) {

    console.log("recentlyViewd", product)
  if (!product || !product.id) return;
  const cleanProduct = createCleanProductObject(product);
  if (!cleanProduct) return;
  let recentlyViewed = JSON.parse(sessionStorage.getItem('recentlyViewed')) || [];
  recentlyViewed = recentlyViewed.filter(item => String(item.id) !== String(cleanProduct.id));
  recentlyViewed.unshift(cleanProduct);
  if (recentlyViewed.length > 10) {
    recentlyViewed.pop();
  }
  sessionStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
}

function loadMainProductData() {
  const mainProductContainer = document.getElementById("wishlist-data");
  if (!mainProductContainer) return null;

  const rawProductScript = document.getElementById("wishlist-product-json");
  if (rawProductScript?.textContent) {
    try {
      return JSON.parse(rawProductScript.textContent);
    } catch (e) {
      console.error("Wishlist OMC: Failed to parse main product JSON.", e);
    }
  }

  if (mainProductContainer.dataset.product) {
    try {
      return JSON.parse(mainProductContainer.dataset.product);
    } catch (e) {
      console.error("Wishlist OMC: Failed to parse main product data.", e);
    }
  }

  return null;
}

// --- INITIALIZATION ---
async function main() {
  console.log("Wishlist OMC: Main script started.");
  const dataContainer = await waitForElement("#collection-wishlist-data");
  
  const getSetting = (key, fallback) => dataContainer.dataset[key] || fallback;
  window.wishlistIconSettings = {
    activeColor: getSetting('iconColorActive', '#DA0000'),
    inactiveColor: getSetting('iconColorInactive', '#000000'),
    size: getSetting('iconSize', '27'),
  };
  try {
    window.customerData = JSON.parse(dataContainer.dataset.customer || '{}');
    window.customerId =
      window.customerData?.id ||
      window.customerId ||
      (typeof Shopify !== 'undefined' && Shopify.customer?.id) ||
      null;
    if (window.customerId != null) {
      window.customerId = String(window.customerId);
    }
    window.customerEmail =
      window.customerData?.email ||
      (typeof Shopify !== 'undefined' && Shopify.customer?.email) ||
      window.customerEmail;
  } catch (e) { window.customerData = {}; }

  applyWishlistCountFromStorage();

  rawMainProductData = loadMainProductData();
  if (rawMainProductData) {
    storeRecentlyViewedProduct(rawMainProductData);
  }

  await fetchCampaignSettings();
  await loadInitialWishlist();
  loadComboProductsData();

  if (rawMainProductData) {
    initMainProductIcon(rawMainProductData);
  } else if (document.getElementById('wishlist-icon-container')) {
    dedupeProductPageWishlistButtons();
  }

  watchProductVariantChanges();
  refreshAllWishlistIcons();

  if (document.querySelector('#cart-form, .cart-items__wrapper, cart-items-component, #cart-oos-container')) {
    observeCartWishlistIcons();
    scheduleCartWishlistRetries();
    document.addEventListener('theme:cart:updated', () => scheduleWishlistIconRefresh(150));
    document.addEventListener('cart:updated', () => scheduleWishlistIconRefresh(150));
    window.addEventListener('load', () => scheduleCartWishlistRetries());
  }

  if (document.querySelector('.wishlist-icon-button')) {
    observeForNewProducts();
  }

  document.addEventListener('pointerdown', function (e) {
    const btn = e.target.closest('.wishlist-icon-button');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const anchor = btn.closest('a');
    if (anchor) {
      anchor.dataset.href = anchor.getAttribute('href');
      anchor.removeAttribute('href');

      setTimeout(() => {
        if (anchor.dataset.href) {
          anchor.setAttribute('href', anchor.dataset.href);
          delete anchor.dataset.href;
        }
      }, 300);
    }
  }, true);

  document.body.addEventListener('click', handleWishlistClick, true);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', main);
} else {
  main();
}
function disableCardOverlayTemporarily(el) {
    const card = el.closest('.card__inner');
    if (!card) return;

    // disable overlay
    card.classList.add('disable-overlay');

    // restore after click
    setTimeout(() => {
        card.classList.remove('disable-overlay');
    }, 300);
}
function extractColorSizeFromProduct(rawProduct, variant) {
  let color = "";
  let size = "";

  // 🔥 CASE 1: Standard 2 options (Color + Size)
  if (rawProduct.options?.length > 1) {
    color = variant.option1 || "";
    size = variant.option2 || "";
  }

  // 🔥 CASE 2: Only 1 option (Size only)
  else {
    size = variant.option1 || "";

    // Extract color from product title
    // Example: "Ballsy Blue Full Sleeves V-Neck T-shirt"
    const title = rawProduct.title || "";

    // Try to extract first 2 words as color
    const words = title.split(" ");
    color = words.slice(0, 2).join(" "); // "Ballsy Blue"
  }

  return { color, size };
}
function buildSelectedVariantEntry(rawProduct, variant) {
  if (!variant?.id) return null;

  const { color, size } = extractColorSizeFromProduct(rawProduct, variant);
  return {
    id: String(variant.id),
    productId: String(normalizeProductId(rawProduct.id)),
    title: `${color}${size ? " / " + size : ""}`,
    quantity: 1,
    color,
    size
  };
}

function normalizeImageUrl(url) {
  if (!url) return '';
  const str = String(url).split('?')[0];
  const parts = str.split('/');
  return parts[parts.length - 1] || '';
}

function imageUrlsMatch(a, b) {
  if (!a || !b) return false;
  const na = normalizeImageUrl(a);
  const nb = normalizeImageUrl(b);
  return !!(na && nb && na === nb);
}

function getVariantImageUrl(variant) {
  if (!variant) return '';
  if (typeof variant.featured_image === 'string') return variant.featured_image;
  if (variant.featured_image?.src) return variant.featured_image.src;
  if (variant.image) return variant.image;
  if (variant.featured_media?.preview_image?.src) return variant.featured_media.preview_image.src;
  return '';
}

function isCartWishlistIcon(iconEl) {
  if (!iconEl) return false;

  if (iconEl.closest(
    '#cart-form, .cart-items__wrapper, cart-items-component, #cart-oos-container, .cart-items__quantity-controls'
  )) {
    return true;
  }

  return /\/cart\b/.test(window.location.pathname) &&
    !!iconEl.closest('.cart-items__table-row, .cart-item__table-main');
}

function getWishlistedProductIdSet() {
  const ids = new Set();
  (_wishlistCache.items || []).forEach((item) => {
    const productId = normalizeProductId(item?.id ?? item?.product_id);
    if (productId) ids.add(productId);
  });
  return ids;
}

function applyWishlistIconState(iconEl, isInWishlist) {
  if (!iconEl.querySelector('svg') || iconEl.dataset.wishlistState !== String(isInWishlist)) {
    iconEl.innerHTML = createHeartSVG(isInWishlist);
    iconEl.dataset.wishlistState = String(isInWishlist);
  }

  iconEl.removeAttribute('data-wishlist-pending');
  iconEl.style.removeProperty('visibility');
}

function syncCartWishlistIcon(iconEl) {
  if (!_wishlistCache.loaded || iconEl.dataset.processing === 'true') return;

  const productId = normalizeProductId(iconEl.dataset.productId || getProductIdFromIconEl(iconEl));
  if (!productId) return;

  applyWishlistIconState(iconEl, getWishlistedProductIdSet().has(productId));
}

function refreshCartWishlistIcons() {
  if (!_wishlistCache.loaded) return;

  const selector = [
    '#cart-form .wishlist-icon-button',
    '.cart-items__wrapper .wishlist-icon-button',
    '#cart-oos-container .wishlist-icon-button',
    'cart-items-component .wishlist-icon-button',
  ].join(', ');

  document.querySelectorAll(selector).forEach(syncCartWishlistIcon);
}

function observeCartWishlistIcons() {
  const targets = [
    document.getElementById('cart-form'),
    document.getElementById('cart-oos-container'),
    document.querySelector('.cart-items__list'),
    document.querySelector('cart-items-component'),
  ].filter(Boolean);

  if (!targets.length) return;

  let debounceTimer = null;
  const observer = new MutationObserver(() => {
    if (!_wishlistCache.loaded) return;
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      debounceTimer = null;
      refreshCartWishlistIcons();
    }, 120);
  });

  targets.forEach((target) => {
    observer.observe(target, { childList: true, subtree: true });
  });
}

function scheduleCartWishlistRetries() {
  [0, 300, 700, 1200, 2000, 3500].forEach((delay) => {
    setTimeout(() => {
      if (_wishlistCache.loaded) refreshCartWishlistIcons();
    }, delay);
  });
}

function getCartLineVariantId(iconEl) {
  if (!iconEl) return '';

  const fromDataset = iconEl.dataset?.variantId;
  if (fromDataset) return String(fromDataset);

  const row = iconEl.closest('.cart-items__table-row');
  if (!row) return '';

  const variantSource = row.querySelector('[data-variant-id]');
  if (variantSource?.dataset?.variantId) {
    return String(variantSource.dataset.variantId);
  }

  const qtyInput = row.querySelector('input[name^="updates["]');
  if (qtyInput?.name) {
    const match = qtyInput.name.match(/updates\[(\d+)\]/);
    if (match) return match[1];
  }

  return '';
}

function getWishlistContext(iconEl) {
  const explicit = iconEl?.dataset?.context;
  if (explicit === 'product') return 'product';
  if (isCartWishlistIcon(iconEl)) return 'cart';
  return explicit || 'collection';
}

function getVariantIdFromCollectionCard(iconEl) {
  if (!iconEl) return '';

  const fromDataset = iconEl.dataset?.variantId;
  if (fromDataset) return String(fromDataset);

  const cardLink = iconEl.closest('a[href*="variant="]');
  if (cardLink) {
    const href = cardLink.getAttribute('href') || '';
    try {
      const url = new URL(href, window.location.origin);
      const variantParam = url.searchParams.get('variant');
      if (variantParam) return String(variantParam);
    } catch (e) {
      const match = href.match(/[?&]variant=(\d+)/);
      if (match) return match[1];
    }
  }

  return '';
}

function getCardDisplayImage(iconEl) {
  if (!iconEl) return '';

  const card = iconEl.closest('.ui-product-card, .card-wrapper, .product-item, a[href*="/products/"]');
  if (!card) return '';

  const img = card.querySelector(
    '.ui-product-card__image img, .card__media img, .product-item__image img, img'
  );
  return img?.currentSrc || img?.src || img?.getAttribute('src') || '';
}

function resolveCollectionCardVariant(rawProduct, iconEl) {
  const variants = normalizeProductVariants(rawProduct);
  if (!variants.length) return null;

  const variantIdFromCard = getVariantIdFromCollectionCard(iconEl);
  if (variantIdFromCard) {
    const fromUrl = variants.find(v => String(v.id) === variantIdFromCard);
    if (fromUrl) return fromUrl;
  }

  const explicitVariantId =
    rawProduct?.variant_id ||
    rawProduct?.variantId;

  if (explicitVariantId) {
    const fromJson = variants.find(v => String(v.id) === String(explicitVariantId));
    if (fromJson) return fromJson;
  }

  const cardImage = getCardDisplayImage(iconEl);
  if (cardImage) {
    for (const variant of variants) {
      const variantImage = getVariantImageUrl(variant);
      if (variantImage && imageUrlsMatch(cardImage, variantImage)) {
        return variant;
      }
    }
  }

  return null;
}

function resolveSelectedVariants(rawProduct, context, iconEl = null) {
  if (context === "product") {
    const fromCombo = getSelectedVariants();
    if (fromCombo.length) return fromCombo;

    const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    const selectedVariantId = variantInput?.value;
    const variants = normalizeProductVariants(rawProduct);

    const defaultVariant =
      variants.find(v => String(v.id) === String(selectedVariantId)) ||
      variants.find(v => v.available) ||
      variants[0];

    if (defaultVariant) {
      const entry = buildSelectedVariantEntry(rawProduct, defaultVariant);
      return entry ? [entry] : [];
    }

    return [];
  }

  if (context === "cart") {
    const variantId = getCartLineVariantId(iconEl);
    if (!variantId) return [];

    const variants = normalizeProductVariants(rawProduct);
    const cartVariant = variants.find(v => String(v.id) === String(variantId));
    if (!cartVariant) return [];

    const entry = buildSelectedVariantEntry(rawProduct, cartVariant);
    return entry ? [entry] : [];
  }

  const collectionVariant = resolveCollectionCardVariant(rawProduct, iconEl);
  if (!collectionVariant) return [];

  const entry = buildSelectedVariantEntry(rawProduct, collectionVariant);
  return entry ? [entry] : [];
}

function normalizeProductVariants(rawProduct) {
  const variants = rawProduct?.variants;
  if (Array.isArray(variants)) return variants;
  if (variants && typeof variants === "object") return Object.values(variants);
  return [];
}

async function handleWishlistClick(event) {
  const iconButton = event.target.closest('.wishlist-icon-button');
  if (!iconButton) return;

  disableCardOverlayTemporarily(iconButton);

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  if (event.cancelable) event.returnValue = false;

  if (iconButton.dataset.processing === 'true') return;
  iconButton.dataset.processing = 'true';

  try {
    const rawProduct = getRawProductFromIcon(iconButton);
    if (!rawProduct) return;

    const context = getWishlistContext(iconButton);
    const selectedVariants = resolveSelectedVariants(rawProduct, context, iconButton);

    console.log("Selected variants:", selectedVariants);
    await toggleWishlistIcon(iconButton, rawProduct, selectedVariants, context);

  } catch (e) {
    console.error('Wishlist OMC: Error handling wishlist click.', e);
  } finally {
    iconButton.dataset.processing = 'false';
  }
}

async function toggleWishlistIcon(element, rawProduct, selectedVariants, context = 'collection') {
  if (window.customerId) {
    await toggleLoggedInWishlist(element, rawProduct, selectedVariants, context);
    return;
  }

  const cleanProduct = createCleanProductObject(rawProduct, selectedVariants);
  if (!cleanProduct) return;

  let wishlist = [];
  try {
    wishlist = JSON.parse(sessionStorage.getItem('wishlist') || '[]');
    if (!Array.isArray(wishlist)) wishlist = [];
  } catch {
    wishlist = [];
  }

  const index = findWishlistItemIndex(wishlist, cleanProduct, selectedVariants, context);

  if (index !== -1) {
    const updatedWishlist = removeWishlistItemAt(wishlist, index);
    element.innerHTML = createHeartSVG(false);
    element.dataset.wishlistState = 'false';
    sessionStorage.setItem('wishlist', JSON.stringify(updatedWishlist));
    _wishlistCache.items = updatedWishlist;
    syncWishlistCountFromItems(updatedWishlist);
    refreshAllWishlistIcons();
    return;
  }

  redirectGuestToLoginForWishlist(rawProduct, selectedVariants);
}

const AUTH_DASHBOARD_PATH = '/pages/ax-customer-dashboard';
const WISHLIST_PENDING_LOGIN_KEY = 'wishlist_pending_login';
let _pendingGuestWishlistAdd = null;

function persistPendingGuestWishlistAdd(pending) {
  _pendingGuestWishlistAdd = pending;
  try {
    sessionStorage.setItem(WISHLIST_PENDING_LOGIN_KEY, JSON.stringify({
      cleanProduct: pending.cleanProduct,
      selectedVariants: pending.selectedVariants,
      productId: pending.productId
    }));
  } catch (e) {
    console.warn('Wishlist OMC: Could not persist pending wishlist add.', e);
  }
}

function clearPendingGuestWishlistAdd() {
  _pendingGuestWishlistAdd = null;
  try {
    sessionStorage.removeItem(WISHLIST_PENDING_LOGIN_KEY);
  } catch (e) {}
}

function getPendingGuestWishlistAdd() {
  if (_pendingGuestWishlistAdd) return _pendingGuestWishlistAdd;

  try {
    const raw = sessionStorage.getItem(WISHLIST_PENDING_LOGIN_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (!parsed?.cleanProduct) return null;

    return {
      cleanProduct: parsed.cleanProduct,
      selectedVariants: Array.isArray(parsed.selectedVariants) ? parsed.selectedVariants : [],
      productId: parsed.productId || parsed.cleanProduct.id,
      iconElement: null
    };
  } catch {
    return null;
  }
}

function setWishlistPostLoginRedirect() {
  const currentUrl = window.location.pathname + window.location.search;
  try {
    sessionStorage.setItem('axentra_post_login_url', currentUrl);
    sessionStorage.setItem('axentra_final_redirect_url', currentUrl);
  } catch (e) {
    console.warn('Wishlist OMC: Could not set post-login redirect.', e);
  }
}

function redirectGuestToLoginForWishlist(rawProduct, selectedVariants) {
  setWishlistPostLoginRedirect();

  const cleanProduct = createCleanProductObject(rawProduct, selectedVariants);
  if (cleanProduct) {
    persistPendingGuestWishlistAdd({
      cleanProduct,
      selectedVariants,
      productId: cleanProduct.id,
      iconElement: null
    });
  }

  window.location.href = AUTH_DASHBOARD_PATH;
}

async function syncPendingLoginWishlistAfterAuth() {
  const pending = getPendingGuestWishlistAdd();
  if (!pending || !window.customerId) return;

  const { cleanProduct, selectedVariants = [] } = pending;
  if (!cleanProduct) {
    clearPendingGuestWishlistAdd();
    return;
  }

  const index = findWishlistItemIndex(_wishlistCache.items, cleanProduct, selectedVariants);
  let newWishlist = _wishlistCache.items;

  if (index === -1) {
    newWishlist = [..._wishlistCache.items, {
      ...cleanProduct,
      dateAdded: new Date().toISOString()
    }];
  }

  const saved = await saveWishlist1(newWishlist, cleanProduct, null);
  if (saved) {
    _wishlistCache.items = newWishlist;
    syncWishlistCountFromItems(newWishlist);
    clearPendingGuestWishlistAdd();
    console.log('Wishlist OMC: Pending post-login wishlist item synced.');
  } else {
    console.warn('Wishlist OMC: Could not sync pending post-login wishlist item.');
  }
}
// --- CORE WISHLIST LOGIC ---

async function toggleLoggedInWishlist(element, rawProduct, selectedVariants, context = 'collection') {

  try {
    const response = await fetch(`${baseURL}/wishlist/get_metafield/?customerId=${window.customerId}&shop=${Shopify.shop}&app=oh_my_customer`);
    const data = await response.json();

    const metafield = (data.metafields?.metafields || [])
      .find(mf => mf.namespace === "wishlist" && mf.key === "items");

    applyWishlistFromMetafieldResponse(metafield);

  } catch (error) {
    console.error("Wishlist sync error:", error);
  }

  const cleanProduct = createCleanProductObject(rawProduct, selectedVariants);
  if (!cleanProduct) return;

  const currentWishlist = _wishlistCache.items || [];
  const index = findWishlistItemIndex(currentWishlist, cleanProduct, selectedVariants, context);

  let newWishlist;

  if (index === -1) {
    newWishlist = [...currentWishlist, {
      ...cleanProduct,
      dateAdded: new Date().toISOString()
    }];

    _wishlistCache.items = newWishlist;
    syncWishlistCountFromItems(newWishlist);
    element.innerHTML = createHeartSVG(true);
    element.dataset.wishlistState = 'true';
    AxentraWishlistPDF("Added to Wishlist", "", "success");

  } else {
    newWishlist = removeWishlistItemAt(currentWishlist, index);

    _wishlistCache.items = newWishlist;
    syncWishlistCountFromItems(newWishlist);
    element.innerHTML = createHeartSVG(false);
    element.dataset.wishlistState = 'false';
    AxentraWishlistPDF("Item removed from Wishlist", "", "removed");
  }

  const saved = await saveWishlist1(newWishlist, cleanProduct, null);
  if (!saved) {
    _wishlistCache.items = currentWishlist;
    syncWishlistCountFromItems(currentWishlist);
    element.innerHTML = createHeartSVG(index !== -1);
    element.dataset.wishlistState = String(index !== -1);
    AxentraWishlistPDF("Could not save wishlist", "", "error");
    return;
  }

  refreshAllWishlistIcons();
}



// --- API & DATA HANDLING ---
const baseURL = `https://omc.axentraos.co.in`;

async function fetchCampaignSettings() {
    try {
      const app = 'oh_my_customer';
      const url = `${baseURL}/campaign/get_campaigns_shopify/?shop=${Shopify.shop}&app=${app}`;
      const response = await fetch(url);
      if (!response.ok) {
        console.warn("Wishlist OMC: Could not fetch campaign settings. Reminders will be disabled.");
        return; // Keep default isReminderEnabled = false
      }
      const data = await response.json();

      // Safely navigate the JSON object to find the reminder setting
      const campaign = data?.campaigns?.[0];
      const features = campaign?.campaign_json?.modules?.myWishlist?.features;

      if (features && Array.isArray(features)) {
        const reminderFeature = features.find(feature => feature.id === 'Reminders');
        if (reminderFeature) {
          isReminderEnabled = reminderFeature.enabled;
        }
      }
      console.log(`Wishlist OMC: Reminders feature is ${isReminderEnabled ? 'ENABLED' : 'DISABLED'}.`);
    } catch (error) {
      console.error("Wishlist OMC: Error fetching campaign settings:", error);
      // isReminderEnabled will remain false in case of an error
    }
}
function getProductIdFromIconEl(iconEl) {
  if (!iconEl) return '';

  const fromDataset = normalizeProductId(iconEl.dataset.productId);
  if (fromDataset) return fromDataset;

  try {
    if (iconEl.dataset.productJson) {
      const raw = normalizeRawProduct(JSON.parse(iconEl.dataset.productJson), iconEl);
      return normalizeProductId(raw.id);
    }
  } catch (e) {}

  return '';
}

function getRawProductFromIcon(iconEl) {
  if (iconEl?.dataset?.productJson) {
    return normalizeRawProduct(JSON.parse(iconEl.dataset.productJson), iconEl);
  }

  if (rawMainProductData) {
    return normalizeRawProduct(rawMainProductData, iconEl);
  }

  const productScript = document.getElementById('wishlist-product-json');
  if (productScript?.textContent) {
    return normalizeRawProduct(JSON.parse(productScript.textContent), iconEl);
  }

  const mainProductContainer = document.getElementById('wishlist-data');
  if (mainProductContainer?.dataset?.product) {
    return normalizeRawProduct(JSON.parse(mainProductContainer.dataset.product), iconEl);
  }

  const productId = getProductIdFromIconEl(iconEl);
  return productId ? { id: productId } : null;
}

function isProductWishlisted(productId, selectedVariants = [], context = 'collection', iconEl = null) {
  const normalizedId = normalizeProductId(productId);
  if (!normalizedId) return false;

  const stubProduct = {
    id: normalizedId,
    key: buildWishlistKey(normalizedId, selectedVariants)
  };

  return findWishlistItemIndex(_wishlistCache.items, stubProduct, selectedVariants, context, iconEl) !== -1;
}

function isWishlistIconFilled(iconEl) {
  const productId = getProductIdFromIconEl(iconEl);
  if (!productId) return false;

  if (isCartWishlistIcon(iconEl)) {
    return getWishlistedProductIdSet().has(normalizeProductId(productId));
  }

  const context = getWishlistContext(iconEl);
  let selectedVariants = [];

  try {
    const rawProduct = getRawProductFromIcon(iconEl);
    if (rawProduct) {
      selectedVariants = resolveSelectedVariants(rawProduct, context, iconEl);
    }
  } catch (e) {}

  return isProductWishlisted(productId, selectedVariants, context, iconEl);
}

function syncWishlistIconElement(iconEl) {
  if (!_wishlistCache.loaded || iconEl.dataset.processing === 'true') return;

  if (isCartWishlistIcon(iconEl)) {
    syncCartWishlistIcon(iconEl);
    return;
  }

  const isInWishlist = isWishlistIconFilled(iconEl);
  applyWishlistIconState(iconEl, isInWishlist);
}

function setupWishlistIconElement(iconEl) {
  if (!iconEl.hasAttribute('data-wishlist-initialized')) {
    iconEl.setAttribute('data-wishlist-initialized', 'true');
  }

  if (isCartWishlistIcon(iconEl) && !_wishlistCache.loaded) {
    iconEl.setAttribute('data-wishlist-pending', 'true');
    iconEl.style.visibility = 'hidden';
  }

  syncWishlistIconElement(iconEl);
}

function collectWishlistIconElements(root) {
  if (!root || root.nodeType !== Node.ELEMENT_NODE) return [];

  if (root.matches?.('.wishlist-icon-button')) {
    return [root];
  }

  return Array.from(root.querySelectorAll('.wishlist-icon-button'));
}

function renderInitialIconStates() {
  console.log("Wishlist OMC: Rendering initial icon states.");
  document.querySelectorAll('.wishlist-icon-button').forEach(syncWishlistIconElement);
}

let _wishlistRefreshTimer = null;

function refreshAllWishlistIcons() {
  if (!_wishlistCache.loaded) return;

  dedupeProductPageWishlistButtons();
  renderInitialIconStates();
  refreshCartWishlistIcons();
  requestAnimationFrame(() => {
    if (!_wishlistCache.loaded) return;
    dedupeProductPageWishlistButtons();
    renderInitialIconStates();
    refreshCartWishlistIcons();
  });
}

function scheduleWishlistIconRefresh(delay = 150) {
  if (_wishlistRefreshTimer) clearTimeout(_wishlistRefreshTimer);
  _wishlistRefreshTimer = setTimeout(() => {
    _wishlistRefreshTimer = null;
    refreshAllWishlistIcons();
  }, delay);
}

window.refreshAllWishlistIcons = refreshAllWishlistIcons;
window.refreshCartWishlistIcons = refreshCartWishlistIcons;
window.scheduleWishlistIconRefresh = scheduleWishlistIconRefresh;

function dedupeProductPageWishlistButtons() {
  const container = document.getElementById('wishlist-icon-container');
  if (container) resolveProductWishlistButton(container);

  const productButtons = Array.from(
    document.querySelectorAll('.wishlist-icon-button[data-context="product"]')
  );

  if (productButtons.length <= 1) return;

  const primary =
    resolveProductWishlistButton(container) ||
    productButtons.find((btn) => btn.closest('#wishlist-icon-container')) ||
    productButtons[0];

  productButtons.forEach((btn) => {
    if (btn !== primary) btn.remove();
  });
}

window.refreshWishlistIcons = refreshAllWishlistIcons;

async function loadInitialWishlist() {
    if (_wishlistCache.loaded) return;
    console.log("Wishlist OMC: Performing initial wishlist fetch...");

    if (window.customerId) {
        try {
            const response = await fetch(`${baseURL}/wishlist/get_metafield/?customerId=${window.customerId}&shop=${Shopify.shop}&app=oh_my_customer`);
            if (!response.ok) throw new Error(`API responded with status ${response.status}`);
            const data = await response.json();
            const metafield = (data.metafields?.metafields || []).find(mf => mf.namespace === "wishlist" && mf.key === "items");
            if (metafield) {
                applyWishlistFromMetafieldResponse(metafield);
            } else {
                await createEmptyMetafield();
                syncWishlistCountFromItems(_wishlistCache.items);
            }

            await syncSessionWishlistToMetafield1();
            await syncPendingLoginWishlistAfterAuth();
            console.log("Wishlist OMC: Guest session wishlist sync attempted.");

        } catch (error) {
            console.error("Wishlist OMC: Error during initial wishlist load.", error);
            await syncSessionWishlistToMetafield1();
            await syncPendingLoginWishlistAfterAuth();
        }
    } else {
        try {
            const guestWishlistRaw = sessionStorage.getItem("wishlist");
            const items = guestWishlistRaw ? JSON.parse(guestWishlistRaw) : [];
            _wishlistCache.items = normalizeWishlistItems(Array.isArray(items) ? items : []);
        } catch {
            _wishlistCache.items = [];
        }
        sessionStorage.setItem("wishlist", JSON.stringify(_wishlistCache.items));
    }

    _wishlistCache.loaded = true;
    syncWishlistCountFromItems(_wishlistCache.items);
    console.log("Wishlist OMC: Initial wishlist loaded into cache.", _wishlistCache);
    renderInitialIconStates();
    refreshCartWishlistIcons();
    
    // Observe new DOM nodes to render their initial state
    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
                if (node.nodeType !== Node.ELEMENT_NODE) continue;
                handleWishlistIconsAdded(node);
            }
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
}


async function saveWishlist1(wishlist, product, reminderDetails) {
  if (window.customerId) {
    if (!_wishlistCache.metafieldId) {
      console.log("Wishlist OMC: No metafield ID found. Initiating first-time save process.");

      const sessionWishlist = JSON.parse(sessionStorage.getItem("wishlist")) || [];
      const combinedWishlist = mergeWishlistItems(wishlist, sessionWishlist);

      const creationSuccess = await createEmptyMetafield();

      if (creationSuccess) {
        console.log("Wishlist OMC: Empty metafield created. Now updating with items.");
        const saved = await updateMetafield(combinedWishlist, product, reminderDetails);
        if (saved) {
          sessionStorage.removeItem("wishlist");
        } else {
          _wishlistCache.items = combinedWishlist;
          syncWishlistCountFromItems(combinedWishlist);
        }
        return saved;
      }

      console.error("Wishlist OMC: Failed to create metafield, cannot save wishlist. Caching locally.");
      _wishlistCache.items = combinedWishlist;
      syncWishlistCountFromItems(combinedWishlist);
      return false;
    }

    return await updateMetafield(wishlist, product, reminderDetails);
  }

  sessionStorage.setItem("wishlist", JSON.stringify(wishlist));
  syncWishlistCountFromItems(wishlist);
  console.log("Wishlist OMC: Saved to session storage for guest user.");
  return true;
}

async function createEmptyMetafield() {
    if (!window.customerId) return false;
    try {
        const payload = {
            customerId: window.customerId, shop: Shopify.shop, app: "oh_my_customer",
            metafield: { namespace: "wishlist", key: "items", value: JSON.stringify([]), type: "json" },
        };
        const response = await fetch(`${baseURL}/wishlist/create_metafield/`, {
            method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload),
        });
        if (!response.ok) throw new Error(`API responded with status ${response.status}`);
        const newData = await response.json();
        if (newData?.metafield?.id) {
            _wishlistCache.metafieldId = newData.metafield.id;
            console.log("Wishlist OMC: Successfully created new empty metafield with ID:", _wishlistCache.metafieldId);
            return true;
        } else {
            throw new Error("Create metafield response did not contain a valid ID.");
        }
    } catch (error) {
        console.error("Wishlist OMC: Error creating empty metafield:", error);
        return false;
    }
}

async function updateMetafield(wishlist, product, reminderDetails) {
    if (!window.customerId || !_wishlistCache.metafieldId) {
        console.error("Wishlist OMC: Cannot update metafield without customerId and metafieldId.");
        return false;
    }
    try {
        const productId = product?.id ?? wishlist[wishlist.length - 1]?.id ?? '';
        const payload = {
            customerId: window.customerId,
            metafieldId: _wishlistCache.metafieldId,
            shop: Shopify.shop,
            app: "oh_my_customer",
            metafield: { id: _wishlistCache.metafieldId, value: JSON.stringify(wishlist), type: "json" },
            productId,
            caldate: reminderDetails?.date ?? '',
            caltime: reminderDetails?.time ?? '',
            email: window.customerEmail ?? ''
        };
        const response = await fetch(`${baseURL}/wishlist/update_metafield/`, {
            method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok || data.success === false) {
            throw new Error(data.message || `API responded with status ${response.status}`);
        }
        _wishlistCache.items = wishlist;
        syncWishlistCountFromItems(wishlist);
        console.log("Wishlist OMC: Background save to metafield successful.");
        return true;
    } catch (error) {
        console.error("Wishlist OMC: Error saving wishlist to metafield:", error);
        return false;
    }
}

function normalizeRawProduct(rawProduct, iconButton) {
  const productId = normalizeProductId(
    rawProduct?.id ??
    rawProduct?.product_id ??
    iconButton?.dataset?.productId
  );

  return {
    ...rawProduct,
    id: productId || undefined
  };
}

function buildWishlistKey(productId, selectedVariants = []) {
  const normalizedId = normalizeProductId(productId);
  const variantIds = selectedVariants.length
    ? selectedVariants.map(v => String(v.id)).sort()
    : ["no-variant"];
  return `${normalizedId}-${variantIds.join("-")}`;
}

function getWishlistItemKey(item) {
  if (item?.key) return String(item.key);

  const productId = normalizeProductId(item?.id ?? item?.product_id);
  if (!productId) return "";

  const selectedVariants = Array.isArray(item?.selectedVariants) ? item.selectedVariants : [];
  return buildWishlistKey(productId, selectedVariants);
}

function findWishlistItemIndex(wishlist, cleanProduct, selectedVariants = [], context = 'collection', iconEl = null) {
  if (!Array.isArray(wishlist) || !cleanProduct) return -1;

  const productId = normalizeProductId(cleanProduct.id);
  if (!productId) return -1;

  const targetKey = getWishlistItemKey(cleanProduct);

  const exactKeyIndex = wishlist.findIndex(item => getWishlistItemKey(item) === targetKey);
  if (exactKeyIndex !== -1) return exactKeyIndex;

  // Cart lines: show filled if the product exists in wishlist under any variant.
  if (context === 'cart') {
    return wishlist.findIndex(
      item => normalizeProductId(item.id ?? item.product_id) === productId
    );
  }

  // Collection cards with a resolved variant only match that exact variant entry.
  if (selectedVariants.length > 0 && context !== 'product' && context !== 'cart') {
    return -1;
  }

  // Collection cards tied to a specific variant URL must not fall back to product-level.
  if (context === 'collection' && getVariantIdFromCollectionCard(iconEl)) {
    return -1;
  }

  // Product-level wishlist: any saved entry for this product.
  if (!selectedVariants.length) {
    return wishlist.findIndex(
      item => normalizeProductId(item.id ?? item.product_id) === productId
    );
  }

  // Product page with variants: also match items added without a specific variant.
  if (context === 'product') {
    return wishlist.findIndex(item => {
      const itemProductId = normalizeProductId(item.id ?? item.product_id);
      if (itemProductId !== productId) return false;

      const itemVariants = Array.isArray(item.selectedVariants) ? item.selectedVariants : [];
      return itemVariants.length === 0;
    });
  }

  return -1;
}

function removeWishlistItemAt(wishlist, index) {
  if (index < 0) return wishlist;
  const next = [...wishlist];
  next.splice(index, 1);
  return next;
}

function mergeWishlistItems(baseItems, extraItems) {
  const combined = [...baseItems];
  const existingKeys = new Set(baseItems.map(getWishlistItemKey).filter(Boolean));
  const existingProductIds = new Set(
    baseItems.map(item => normalizeProductId(item.id ?? item.product_id)).filter(Boolean)
  );

  extraItems.forEach((item) => {
    const key = getWishlistItemKey(item);
    const productId = normalizeProductId(item.id ?? item.product_id ?? "");
    const hasVariants = Array.isArray(item.selectedVariants) && item.selectedVariants.length > 0;

    if (key && existingKeys.has(key)) return;
    if (!hasVariants && productId && existingProductIds.has(productId)) return;

    combined.push(item);
    if (key) existingKeys.add(key);
    if (productId) existingProductIds.add(productId);
  });

  return combined;
}

async function syncSessionWishlistToMetafield1() {
  let sessionWishlist = [];

  try {
    sessionWishlist = JSON.parse(sessionStorage.getItem("wishlist") || "[]");
    if (!Array.isArray(sessionWishlist)) sessionWishlist = [];
  } catch {
    sessionWishlist = [];
  }

  if (!sessionWishlist.length || !window.customerId) return;

  console.log("Wishlist OMC: Found items in session. Syncing to user's account...");

  const combined = mergeWishlistItems(_wishlistCache.items, sessionWishlist);
  const itemsWereAdded = combined.length > _wishlistCache.items.length;

  if (itemsWereAdded) {
    const saved = await saveWishlist1(combined, null, null);
    if (saved) {
      sessionStorage.removeItem("wishlist");
      console.log("Wishlist OMC: Guest-to-user sync complete.");
    } else {
      _wishlistCache.items = combined;
      syncWishlistCountFromItems(combined);
      console.warn("Wishlist OMC: Guest-to-user sync failed; session wishlist preserved for retry.");
    }
    return;
  }

  sessionStorage.removeItem("wishlist");
  console.log("Wishlist OMC: Session wishlist contained only duplicates, cleared session.");
}

// Backward-compatible alias used by other theme scripts.
window.syncSessionWishlistToMetafield = syncSessionWishlistToMetafield1;

// --- PAGE-SPECIFIC INITIALIZERS ---
function resolveProductWishlistButton(container) {
  if (!container) return null;

  // Theme uses the container element itself as the clickable heart.
  if (container.classList.contains('wishlist-icon-button')) {
    container.querySelectorAll('.wishlist-icon-button').forEach((nested) => {
      if (nested !== container) nested.remove();
    });
    return container;
  }

  // Wrapper container: keep a single direct child button.
  const directButtons = Array.from(
    container.querySelectorAll(':scope > .wishlist-icon-button')
  );
  directButtons.slice(1).forEach((extra) => extra.remove());

  if (directButtons[0]) return directButtons[0];

  const nestedButtons = Array.from(container.querySelectorAll('.wishlist-icon-button'));
  nestedButtons.slice(1).forEach((extra) => extra.remove());
  return nestedButtons[0] || null;
}

function initMainProductIcon(rawProduct) {
  if (!rawProduct) return;

  const normalizedProduct = normalizeRawProduct(rawProduct);
  const container = document.getElementById('wishlist-icon-container');
  let btn = resolveProductWishlistButton(container);

  // Theme may render the product heart outside #wishlist-icon-container.
  if (!btn) {
    const themeButtons = Array.from(
      document.querySelectorAll('.wishlist-icon-button[data-context="product"]')
    );
    themeButtons.slice(1).forEach((extra) => extra.remove());
    btn = themeButtons[0] || null;
  }

  if (!btn && container) {
    btn = document.createElement('span');
    btn.className = 'wishlist-icon-button';
    btn.style.cursor = 'pointer';
    container.appendChild(btn);
  }

  if (!btn) return;

  btn.dataset.productId = normalizedProduct.id;
  btn.dataset.productJson = JSON.stringify(normalizedProduct);
  btn.dataset.context = 'product';

  setupWishlistIconElement(btn);
}

function watchProductVariantChanges() {
  const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
  if (!variantInput) return;

  variantInput.addEventListener('change', () => {
    document
      .querySelectorAll('.wishlist-icon-button[data-context="product"]')
      .forEach(syncWishlistIconElement);
  });
}

function initializeCollectionIcons(rootElement) {
  collectWishlistIconElements(rootElement).forEach(setupWishlistIconElement);
}

function handleWishlistIconsAdded(node) {
  const icons = collectWishlistIconElements(node);
  if (!icons.length) return;

  icons.forEach(setupWishlistIconElement);

  if (icons.some(isCartWishlistIcon)) {
    scheduleWishlistIconRefresh(120);
    setTimeout(refreshCartWishlistIcons, 300);
  }
}

function observeForNewProducts() {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;

        if (node.id === 'wishlist-icon-container' || node.querySelector?.('#wishlist-icon-container')) {
          dedupeProductPageWishlistButtons();
        }

        handleWishlistIconsAdded(node);
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}


function createHeartSVG(isFilled) {
  const settings = window.wishlistIconSettings || {};
  const size = settings.size || 25;
  const activeColor = settings.activeColor || "#750000"; // This is the color when saved
  const inactiveColor = "#000000"; // Changed from #737373 to Black

  // If filled, we use the active color (red); if not filled, we use black
  const color = isFilled ? activeColor : inactiveColor;
  const fillColor = isFilled ? color : "none";

  return `
    <svg
      width="${size}"
      height="${size}"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.7082 8.02967C17.6999 5.91645 16.5913 3.92911 14.4055 3.22496C12.9046 2.74062 11.2697 3.00997 9.99996 4.83286C8.73025 3.00997 7.09535 2.74062 5.59445 3.22496C3.40841 3.92919 2.29972 5.9169 2.2917 8.0304C2.27148 12.2335 6.53048 15.4498 9.99888 16.9871L9.99996 16.9866L10.001 16.9871C13.4696 15.4497 17.7289 12.2331 17.7082 8.02967Z"
        style="fill:${fillColor};stroke:${color};stroke-width:1.5"
        stroke-linecap="square"
      />
    </svg>`;
}
function ensureWishlistToastStyles() {
  if (!document.querySelector('link[href*="Manrope"]')) {
    const fontLink = document.createElement("link");
    fontLink.rel = "stylesheet";
    fontLink.href = "https://fonts.googleapis.com/css2?family=Manrope:wght@500&display=swap";
    (document.head || document.documentElement).appendChild(fontLink);
  }

  const cssText =
    ".wishlist-toast-wrapper .wishlist-toast," +
    ".wishlist-toast-wrapper .wishlist-toast * {" +
    "font-family: Manrope, sans-serif !important;" +
    "}" +
    ".wishlist-toast-wrapper.wishlist-toast-mobile {" +
    "position: fixed !important;" +
    "inset: 0 !important;" +
    "top: 0 !important;" +
    "left: 0 !important;" +
    "right: 0 !important;" +
    "bottom: 0 !important;" +
    "display: flex !important;" +
    "align-items: flex-end !important;" +
    "justify-content: center !important;" +
    "width: 100% !important;" +
    "max-width: none !important;" +
    "height: 100% !important;" +
    "margin: 0 !important;" +
    "padding: 0 10vw 20px 10vw !important;" +
    "box-sizing: border-box !important;" +
    "pointer-events: none !important;" +
    "transform: none !important;" +
    "background: transparent !important;" +
    "}" +
    ".wishlist-toast-wrapper.wishlist-toast-mobile .wishlist-toast {" +
    "width: max-content !important;" +
    "max-width: 80vw !important;" +
    "pointer-events: auto !important;" +
    "}" +
    ".wishlist-toast-wrapper.wishlist-toast-mobile .wishlist-toast-title {" +
    "white-space: nowrap !important;" +
    "}" +
    ".wishlist-toast-wrapper.wishlist-toast-desktop {" +
    "width: fit-content !important;" +
    "max-width: 80vw !important;" +
    "}" +
    ".wishlist-toast-wrapper .wishlist-toast-close {" +
    "margin-left: 12px !important;" +
    "padding-left: 4px !important;" +
    "flex-shrink: 0 !important;" +
    "}";

  let style = document.getElementById("wishlist-toast-styles");
  if (style) {
    style.textContent = cssText;
    return;
  }

  style = document.createElement("style");
  style.id = "wishlist-toast-styles";
  style.textContent = cssText;
  (document.head || document.documentElement).appendChild(style);
}

function AxentraWishlistPDF(title, message, status = "success") {
  ensureWishlistToastStyles();

  const isAdded = status === "success";
  const isMobile =
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 767px)").matches;

  document.querySelectorAll(".wishlist-toast-wrapper, .toast-wrapper").forEach((t) => t.remove());

  const wrapper = document.createElement("div");
  wrapper.className = isMobile
    ? "wishlist-toast-wrapper toast-wrapper wishlist-toast-mobile"
    : "wishlist-toast-wrapper toast-wrapper wishlist-toast-desktop";
  wrapper.setAttribute("role", "status");
  wrapper.setAttribute("aria-live", "polite");
  wrapper.style.setProperty("position", "fixed", "important");
  wrapper.style.setProperty("z-index", "2147483646", "important");
  wrapper.style.setProperty("box-sizing", "border-box", "important");

  if (!isMobile) {
    wrapper.style.setProperty("bottom", "20px", "important");
    wrapper.style.setProperty("right", "20px", "important");
    wrapper.style.setProperty("pointer-events", "auto", "important");
  }

  const allowMotion =
    typeof matchMedia === "undefined" ||
    !matchMedia("(prefers-reduced-motion: reduce)").matches;

  const toast = document.createElement("div");
  toast.className = "wishlist-toast";
  toast.style.setProperty("display", "inline-flex", "important");
  toast.style.setProperty("align-items", "center", "important");
  toast.style.setProperty("gap", "12px", "important");
  toast.style.setProperty("padding", "12px 20px", "important");
  toast.style.setProperty("border-radius", "6px", "important");
  toast.style.setProperty("box-shadow", "0 2px 8px rgba(0, 0, 0, 0.12)", "important");
  toast.style.setProperty("box-sizing", "border-box", "important");
  toast.style.setProperty("font-family", "Manrope, sans-serif", "important");

  if (allowMotion) {
    toast.style.opacity = "0";
    toast.style.transform = "translateY(12px)";
    toast.style.transition = "opacity 0.25s ease, transform 0.25s ease";
  }

  const iconColor = isAdded ? "#ffffff" : "#212121";
  const textColor = isAdded ? "#ffffff" : "#212121";

  if (isAdded) {
    toast.style.setProperty("background-color", "#008a3e", "important");
    toast.style.setProperty("border", "none", "important");
  } else {
    toast.style.setProperty("background-color", "#f5f5f5", "important");
    toast.style.setProperty("border", "1px solid #757575", "important");
  }

  const checkIcon = isAdded
    ? `<span class="wishlist-toast-check" style="display:inline-flex!important;align-items:center!important;justify-content:center!important;flex-shrink:0!important;line-height:0!important;">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="${iconColor}" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </span>`
    : "";

  const messageHtml = message
    ? `<span class="wishlist-toast-message" style="display:block!important;margin-top:4px!important;font-family:Manrope,sans-serif!important;font-size:13px!important;font-weight:500!important;line-height:1.35!important;color:${textColor}!important;">${message}</span>`
    : "";

  toast.innerHTML = `
    ${checkIcon}
    <div class="wishlist-toast-content" style="display:flex!important;flex-direction:column!important;flex:0 1 auto!important;min-width:0!important;">
      <span class="wishlist-toast-title" style="display:block!important;font-family:Manrope,sans-serif!important;font-size:15px!important;font-weight:500!important;line-height:1.35!important;color:${textColor}!important;white-space:nowrap!important;">${title}</span>
      ${messageHtml}
    </div>
    <button type="button" class="wishlist-toast-close" aria-label="Close" style="display:inline-flex!important;align-items:center!important;justify-content:center!important;flex-shrink:0!important;background:none!important;border:none!important;padding:0!important;margin:0!important;cursor:pointer!important;line-height:0!important;color:${iconColor}!important;">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  `;

  toast.querySelector(".wishlist-toast-close").addEventListener("click", () => wrapper.remove());
  wrapper.appendChild(toast);
  (document.body || document.documentElement).appendChild(wrapper);

  if (allowMotion) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        toast.style.opacity = "1";
        toast.style.transform = "translateY(0)";
      });
    });
  }

  setTimeout(() => wrapper.remove(), 5000);
}

window.AxentraWishlistPDF = AxentraWishlistPDF;

// This function is no longer called but is kept in case it's needed in the future.
function renderCalendarUI(product_name) {
    const modal = document.createElement("div");
    modal.innerHTML = `
        <div style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);display:flex;justify-content:center;align-items:center;z-index:1000">
            <div style="background:white;padding:20px;width:330px;box-shadow:0 4px 10px rgba(0,0,0,0.3);position:relative; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;">
                <span id="closeCross" style="cursor:pointer;font-size:24px;font-weight:bold;color:#555;position:absolute;right:15px;top:10px; line-height: 1;">&times;</span>
                <div style="text-align:center; margin-bottom: 20px;">
                    <span style="font-size:18px;font-weight:600;color:#111;">Set a Reminder</span>
                </div>
                <div style="padding:10px 0;">
                    <label style="font-size:14px; color:#333; display: block; margin-bottom: 15px;">For Product: <strong style="color: #000;">${product_name}</strong></label>
                    
                    <div style="margin-bottom: 15px;">
                        <label for="reminderDateInput" style="display:block; font-weight:bold; margin-bottom:5px; color:#111; font-size:14px;">Reminder Date</label>
                        <input type="date" id="reminderDateInput" style="width:100%;padding:8px;border-radius:4px;border:1px solid #ccc;font-size:14px;box-sizing: border-box;">
                    </div>

                    <div>
                        <label for="timeSelect" style="display:block; font-weight:bold; margin-bottom:5px; color:#111; font-size:14px;">Reminder Time</label>
                        <select id="timeSelect" style="width:100%;padding:8px;border-radius:4px;border:1px solid #ccc;font-size:14px;box-sizing: border-box; background-color: white;">
                            ${Array.from({ length: 24 }, (_, i) => {
                                const hour = i % 12 === 0 ? 12 : i % 12;
                                const ampm = i < 12 ? "AM" : "PM";
                                return `<option value="${String(i).padStart(2, "0")}:00">${hour}:00 ${ampm}</option>`;
                            }).join("")}
                        </select>
                    </div>
                </div>
                <div style="display:flex;justify-content:end;align-items:center;gap:10px;margin-top:25px;">
                    <button id="closeModal" style="background:#f0f0f0;color:#333;border:1px solid #ccc;padding:8px 16px;cursor:pointer;font-size:14px;font-weight:500;border-radius:4px;">Cancel</button>
                    <button id="setReminder" style="background:black;color:white;border:1px solid black;padding:8px 16px;cursor:pointer;font-size:14px;font-weight:500;border-radius:4px;">Set Reminder</button>
                </div>
            </div>
        </div>
    `;

    const dateInput = modal.querySelector("#reminderDateInput");
    const timeSelect = modal.querySelector("#timeSelect");
    const today = new Date();
    dateInput.min = today.toISOString().slice(0, 10);

    const closeModal = () => {
        modal.remove();
        document.dispatchEvent(new CustomEvent("reminderSet", { detail: null }));
    };
    modal.querySelector("#closeModal").addEventListener("click", closeModal);
    modal.querySelector("#closeCross").addEventListener("click", closeModal);

    modal.querySelector("#setReminder").addEventListener("click", () => {
        const selectedDate = dateInput.value;
        const selectedTime = timeSelect.value;

        if (!selectedDate) {
            AxentraWishlistPDF("Missing Reminder Date", "Please select a date to create your reminder.", "error");
            return;
        }

        const now = new Date();
        const reminderDateTime = new Date(`${selectedDate}T${selectedTime}`);
        
        if (selectedDate === now.toISOString().slice(0, 10) && reminderDateTime <= now) {
            AxentraWishlistPDF("Time Selection Error", "The selected time is in the past. Please choose a future time.", "error");
            return;
        }

        modal.remove();
        document.dispatchEvent(new CustomEvent("reminderSet", { detail: { date: selectedDate, time: selectedTime } }));
    });

    return modal;
}